import { createToast } from "./common"

let catNameChange = null;
window.cartData = {};

// // WebSocket connection
// const socket = new WebSocket(websocket_url);
// socket.onopen = function (event) {
// 	console.log("WebSocket connection established.");
// 	socket.send(
// 		JSON.stringify({
// 			action: "register",
// 			user_id: userId,
// 		})
// 	);
// };

// socket.onmessage = function (event) {
// 	const data = JSON.parse(event.data);i
// 	if (data) {
// 		let serviceVariantArray = data.service.split(",,");
// 		data.service = serviceVariantArray[0];
// 		if (serviceVariantArray[1]) {
// 			data.service_variant = serviceVariantArray[1];
// 		}
// 		console.log("WebSocket message received:", data);
// 		userNames[data.ctg] = data.u_name;
// 		if (cartData[data.ctg]) {
// 			cartData[data.ctg].u_name = data.u_name;
// 		}
// 		localStorage.removeItem("serviceDatatoShow");
// 		updateUserData(data, data.ctg, data.success);
// 		expandAccordion(document.getElementById(`accordion-${data.ctg}`));
// 	}
// };
// socket.onerror = function (error) {
// 	console.error("WebSocket error:", error);
// };
// socket.onclose = function (event) {
// 	console.log("WebSocket connection closed:", event);
// };

const socialCheckboxes = document.querySelectorAll(".social-checkbox");
const sliders = document.querySelectorAll(".slider");
const back = document.querySelector(".backButton");
back.addEventListener("click", function () {
	const referrer = document.referrer;
	if (referrer && referrer.includes(BASE_URL)) {
		window.history.back();
	} else {
		window.location.href = BASE_URL;
	}
});
const userNames = {
	instagram: ig_user_name,
	tiktok: tiktok_user_name,
	youtube: channel_name,
	twitter: twitter_profile_link,
	facebook: fb_profile_link,
	threads: thread_profile_link,
};
$.each(userNames, function (cat, userName) {
	const changeMode = $("#accordion-" + cat + " .change-mode");
	if (userName) {
		changeMode.css("display", "none");
		changeMode.siblings(".active-mode").css("display", "flex");
	} else {
		changeMode.css("display", "flex");
		changeMode.siblings(".active-mode").css("display", "none");
		$("#accordion-" + cat + " .slider").prop("disabled", true);
		$(`[id^='${cat}'][id$='variant']`).prop("disabled", true);
		$(`[id^='${cat}'][id$='breakpoints']`).css("pointer-events", "none");
		$(`[id^='${cat}'][id$='duration']`).prop("disabled", true);
	}
});
const username = localStorage.getItem("socialuser");
localStorage.removeItem("socialuser");
let serviceData = localStorage.getItem("serviceDatatoShow");
if (username) {
	catNameChange = category;
}
const path = window.location.pathname;
const route = path
	.split("/")
	.filter((str) => str !== "")
	.pop();
const segments = route.split("-");
const quantity = segments[1];
const service = segments[3];
const checkbox = document.querySelector(
	`[id^="${category}-"][id$="~${service}-checkbox"]`
);
if (checkbox) {
	checkbox.checked = true;
	setTimeout(() => {
		$(checkbox).trigger("change");
	}, 10);
}
const slider = document.querySelector(
	`[id^="${category}-slider-"][id$="~${service}"]`
);
if (slider) {
	slider.value = quantity;
} else {
	const variantButton = document.querySelector(
		`[class*="${category}-"][class*="~${service}-variant"]`
	);
	if (variantButton) {
		const parent = variantButton.id.split("-")[1];
		const variantCheckbox = document.getElementById(
			`${category}-${parent}-checkbox`
		);
		variantCheckbox.checked = true;
		requestAnimationFrame(() => {
			$(variantCheckbox).trigger("change");
			variantButton.checked = true;
			requestAnimationFrame(() => {
				$(variantButton).trigger("change");
				const service = variantButton.closest(".service");
				const slider = service.querySelector(".slider");
				slider.value = quantity;
				requestAnimationFrame(() => {
					slider.dispatchEvent(new Event("input"));
				});
			});
		});
	}
}
socialCheckboxes.forEach((radio) => {
	const targetId = radio.getAttribute("data-target");
	const targetElement = document.getElementById(targetId);
	if (targetElement) {
		const arrow = targetElement.querySelector(".accordion-arrow");
		const parent = arrow.parentElement;
		const divider = parent.querySelector(".divider");
		if (divider) {
			const dividerY =
				divider.getBoundingClientRect().top -
				parent.getBoundingClientRect().top;
			parent.style.maxHeight = `${dividerY}px`;
		}
		arrow.addEventListener("click", function () {
			if (radio.checked) {
				radio.checked = false;
				collapseAccordion(targetElement);
			} else {
				radio.checked = true;
				expandAccordion(targetElement);
			}
		});
	}
	radio.addEventListener("click", function () {
		if (this.checked) {
			this.checked = false;
			let prev;
			socialCheckboxes.forEach((e) => {
				if (e.checked == true && !prev) {
					prev = e;
				}
			});
			if (prev) {
				let text = $(prev).closest("label").find("h2").text().toLowerCase();
				let a = serviceController(text);
				if (!a) {
					this.checked = false;
					return false;
				}
			}
			this.checked = true;
			socialCheckboxes.forEach((otherRadio) => {
				if (otherRadio !== this) {
					const otherTargetId = otherRadio.getAttribute("data-target");
					const otherTargetElement = document.getElementById(otherTargetId);
					otherTargetElement
						? (otherTargetElement.style.display = "none")
						: null;
					otherRadio.checked = false;
				}
			});
			targetElement.style.display = "flex";
			let activeMode = targetElement.querySelector(".change-mode");
			if (activeMode && !activeMode.classList.contains("hidden")) {
				activeMode.querySelector('input[type="text"]').focus();
			}
			expandAccordion(targetElement);
			setTimeout(() => {
				targetElement.scrollIntoView({ behavior: "smooth" });
			}, 150);
		} else {
			this.checked = true;
		}
	});
});
function expandAccordion(accordion) {
	const arrow = accordion.querySelector(".accordion-arrow");
	const parent = arrow.parentElement;
	const divider = parent.querySelector(".divider");
	if (divider) {
		const fullHeight = parent.scrollHeight;
		parent.style.maxHeight = `${fullHeight + 2}px`;
		arrow.style.transform = "rotate(180deg)";
	}
}
function collapseAccordion(accordion) {
	const arrow = accordion.querySelector(".accordion-arrow");
	const parent = arrow.parentElement;
	const divider = parent.querySelector(".divider");
	if (divider) {
		const dividerY =
			divider.getBoundingClientRect().top - parent.getBoundingClientRect().top;
		parent.style.maxHeight = `${dividerY}px`;
		arrow.style.transform = "rotate(0deg)";
	}
}
if (category) {
	const selectedService = document.getElementById(category + "-checkbox");
	if (selectedService) {
		selectedService.click();
	}
}
window.onload = function () {
	lazyLoadImages();
	if (!sessionCartData) return;
	processCartData(sessionCartData);
};
function lazyLoadImages() {
	const images = document.querySelectorAll("img[data-src]");
	images.forEach((img) => (img.src = img.dataset.src));
}
function processCartData(cartData) {
	if (catNameChange) {
		addToCart(cartData);
	}

	if (serviceData) {
		localStorage.removeItem("serviceDatatoShow");
		let data = JSON.parse(serviceData);
		if (data.service && data.qty) {
			let variansArray = data.service.split(",,");
			data.service = variansArray[0];
			if (variansArray[1]) {
				data.variant_id = variansArray[1];
			}
			let arr = Object.keys(cartData?.[data.ctg] || {});
			let a = false;
			let currentService = arr.find((e) => {
				if (e.split("~")[1] == data.service) {
					a = true;
					return true;
				}
			});
			if (a) {
				delete cartData?.[data.ctg]?.[currentService];
			} else {
				let service = Object.keys(all_packages?.[data.ctg]).find((e) => {
					return e.split("~")[1] == data.service;
				});
				if (service) {
					let subpackagesArray = Object.keys(
						all_packages[data.ctg][service].subpackages
					);
					subpackagesArray.find((e) => {
						delete cartData?.[data.ctg]?.[e];
					});
				}
			}
			let variant = selectServiceFromOtherPage(
				data.ctg,
				data.service,
				data.qty,
				data.variant_id
			);
			if (variant) {
				currentService = arr.find((e) => {
					if (e.split("~")[1] == variant) {
						return true;
					}
				});
				delete cartData?.[data.ctg]?.[currentService];
				let service = Object.keys(all_packages?.[data.ctg]).find((e) => {
					return e.split("~")[1] == variant;
				});
				if (service) {
					let subpackagesArray = Object.keys(
						all_packages[data.ctg][service]?.subpackages
					);
					subpackagesArray?.find((e) => {
						delete cartData?.[data.ctg]?.[e];
					});
				}
			}
		}
	}

	Object.entries(cartData).forEach(([cat, services]) => {
		Object.entries(services).forEach(([serviceType, serviceData]) => {
			const serviceCheckbox = document.getElementById(
				`${cat}-${serviceType}-checkbox`
			);
			const slider = document.getElementById(`${cat}-slider-${serviceType}`);
			selectService(
				cat,
				serviceType,
				serviceCheckbox,
				slider,
				serviceData,
				cartData[cat][serviceType].type
			);
		});
	});
}
function selectServiceFromOtherPage(
	ctg,
	selectedService,
	qty,
	service_variant
) {
	//service_variant like time duration for tiktok etc
	let sliders = [...document.querySelectorAll(`.${ctg}-slider`)];
	let servicetoReturn;
	for (let i = 0; i < sliders.length; i++) {
		let service = sliders[i].id.split("~")[1];
		let packageService = sliders[i].id.split("-")[2];
		let parentService = sliders[i].closest(".service");
		let variants = parentService.querySelectorAll(".variant-radio");
		if (service == selectedService || variants.length) {
			let flag = false;
			if (service == selectedService) {
				let packages = all_packages[ctg][packageService].packages.sort(
					(a, b) => a.packageQty - b.packageQty
				);
				for (let o = 0; o < packages.length; o++) {
					if (packages[o].packageQty == qty) {
						qty = o + 1;
						break;
					}
				}
				flag = true;
			} else {
				if (variants.length) {
					variants = [...variants];
					for (let j = 0; j < variants.length; j++) {
						if (variants[j].id.includes(selectedService)) {
							variants[j].click();
							let packages = all_packages[ctg][packageService].subpackages[
								variants[j].id.split("-")[2]
							].packages.sort((a, b) => a.packageQty - b.packageQty);
							for (let o = 0; o < packages.length; o++) {
								if (packages[o].packageQty == qty) {
									qty = o + 1;
									break;
								}
							}
							servicetoReturn = service;
							flag = true;
							break;
						}
					}
				}
			}
			if (!flag) continue;
			document
				.getElementById(`${ctg}-${sliders[i].id.split("-")[2]}-checkbox`)
				.click();
			sliders[i].value = Number(qty);
			sliders[i].dispatchEvent(new Event("input"));
			if (service_variant) {
				let durations = [
					...sliders[i].closest(".service").querySelectorAll(".duration-radio"),
				];
				for (let i = 0; i < durations.length; i++) {
					if (durations[i].id.includes(service_variant)) {
						durations[i].click();
						break;
					}
				}
			}
			setTimeout(() => {
				sliders[i].scrollIntoView({ behavior: "smooth", block: "center" });
			}, 600);
			break;
		}
	}
	return servicetoReturn;
}
function selectService(
	cat,
	serviceType,
	serviceCheckbox,
	slider,
	serviceData,
	type
) {
	let qty = 0;
	if (slider) {
		const packages = all_packages[cat][serviceType].packages.sort(
			(a, b) => a.packageQty - b.packageQty
		);
		var parent = serviceType;
		for (let i = 0; i < packages.length; i++) {
			if (serviceData.packageQty == packages[i].packageQty) {
				qty = i + 1;
				break;
			}
		}
	}
	if (!slider) {
		const variantButton = document.querySelector(
			`[class*="${serviceData.category}-"][class*="~${
				serviceType.split("~")[1]
			}-variant"]`
		);
		parent = variantButton.id.split("-")[1];
		let packages = all_packages[cat][parent].subpackages[
			serviceType
		].packages.sort((a, b) => a.packageQty - b.packageQty);
		for (let i = 0; i < packages.length; i++) {
			if (serviceData.packageQty == packages[i].packageQty) {
				qty = i + 1;
				break;
			}
		}
		const variantCheckbox = document.getElementById(
			`${serviceData.category}-${parent}-checkbox`
		);
		variantCheckbox.checked = true;
		variantCheckbox.dispatchEvent(new Event("change"));
		variantButton.checked = true;
		variantButton.dispatchEvent(new Event("change"));
		const service = variantButton.closest(".service");
		slider = service.querySelector(".slider");
		slider.value = qty;
	}
	if (serviceCheckbox) {
		serviceCheckbox.checked = true;
		serviceCheckbox.dispatchEvent(new Event("change"));
	}
	if (slider.value == 0) {
		slider.value = qty;
	}
	slider.dispatchEvent(new Event("input"));
	if (serviceData.variant_id) {
		const variantRadio = document.getElementById(
			`${serviceData.category}-${serviceData.variant_id}-duration`
		);
		if (variantRadio) {
			variantRadio.click();
		}
	}
	if (serviceData.postsSelected.length > 0) {
		processPosts(cat, parent, serviceData, type);
	}
}
function processPosts(cat, serviceType, serviceData, type) {
	let postElement = document.getElementById(
		`${cat}-slider-${serviceType}-detail`
	);
	const selectableImage = postElement.querySelector(".selectable-image");
	let service = postElement.closest(".service");
	let checkbox = service.querySelector(".post-input-check");
	let ImageContainer = service.querySelector(`.${cat}-posts-container`);
	const linkInputs = postElement.querySelector(".link-inputs");
	const addMoreButton = postElement.querySelector(".addMore");
	if (type == "manual") {
		if (checkbox) {
			checkbox.checked = true;
			ImageContainer.classList.add("hidden");
		}
	}
	if (selectableImage && type !== "manual") {
		serviceData.postsSelected.forEach((post) => {
			const postImage = postElement.querySelector(`[id='${post.id}']`);
			postImage?.click();
		});
		serviceData.postsSelected.forEach((post) => {
			handleCartPostComments(cat, post);
		});
	} else if (linkInputs) {
		let selectedPostReactions = [];
		serviceData.postsSelected.forEach((post, index) => {
			if (index === 0) {
				const defaultField = linkInputs.querySelector("input");
				linkInputs.parentElement.classList.remove("hidden");
				if (post.reactions) {
					selectedPostReactions.push({
						element: defaultField,
						reactions: post.reactions,
					});
				}
				const perPost = linkInputs.querySelector(".per-post-val span");
				if (defaultField) {
					defaultField.value = post.id;
					defaultField.dispatchEvent(new Event("input", { bubbles: true }));
					perPost.textContent = post.value;
				}
			} else {
				addMoreButton?.click();
				const newField =
					linkInputs.querySelectorAll('input[type="text"]')[index];
				if (post.reactions) {
					selectedPostReactions.push({
						element: newField,
						reactions: post.reactions,
					});
				}
				const perPost =
					linkInputs.querySelectorAll(".per-post-val span")[index];
				if (newField) {
					newField.value = post.id;
					newField.dispatchEvent(new Event("input", { bubbles: true }));
					perPost.textContent = post.value;
				}
			}
		});
		// the code in this if handle the selection of post reactions
		if (selectedPostReactions.length) {
			selectedPostReactions.forEach((e) => {
				let newField = e.element;
				let reactions = e.reactions;
				newField
					.closest(".link-input-wrapper")
					?.querySelector("input:checked")
					?.click();
				let ref;
				for (let k in reactions) {
					let checkInput = newField
						.closest(".link-input-wrapper")
						.querySelector(`input[name="${k}"]`);
					checkInput.checked = true;
					ref = checkInput;
				}
				if (ref) {
					ref.checked = false;
					ref.click();
				}
			});
		}
	}
}
function updateCartData(
	category,
	service,
	packageQty,
	postsSelected = [],
	variant = undefined,
	service2
) {
	if (packageQty > 0) {
		if (!cartData[category]) {
			cartData[category] = {};
		}
		if (!cartData[category]["u_name"]) {
			cartData[category]["u_name"] = userNames[category];
		}
		if (!cartData[category][service]) {
			cartData[category][service] = {};
		}
		cartData[category][service] = {
			...cartData[category][service],
			packageQty,
			postsSelected,
			service2: service2 ? service2 : undefined,
		};
		if (variant) {
			cartData[category][service].variant = variant;
		}
	} else {
		if (cartData[category] && cartData[category][service]) {
			delete cartData[category][service];
			if (Object.keys(cartData[category]).length === 0) {
				delete cartData[category];
			}
		}
	}
}

function calculatePrice(
	packages,
	sliderValue,
	sliderPrevPrice,
	sliderPackagePrice,
	slider
) {
	let selectedVariantId = null;
	const checkedVariantRadio = slider
		.closest(".service")
		?.querySelector(".durations")
		?.querySelector(".duration-radio:checked");

	if (checkedVariantRadio) {
		selectedVariantId = checkedVariantRadio.value;
	}

	if (sliderValue === 0) {
		sliderPackagePrice.innerText = `${packages[0].priceUnit} 0`;
		sliderPrevPrice.innerText = `${packages[0].priceUnit} 0`;
		return;
	}
	let Q1 = null,
		Q2 = null,
		P1 = null,
		P2 = null,
		oldP1 = null,
		oldP2 = null;
	let variant;
	for (let i = 0; i < packages.length; i++) {
		let packagePrice = Number(packages[i].packagePrice);
		let previousPrice = Number(packages[i].previousPrice);
		if (sliderValue === Number(packages[i].packageQty)) {
			if (packages[i].variants && selectedVariantId) {
				variant = packages[i].variants.find(
					(v) => v.duration === selectedVariantId
				);
			}
			sliderPackagePrice.innerText = `${packages[i].priceUnit} ${
				variant?.durationPrice ? variant?.durationPrice : packagePrice
			}`;
			sliderPrevPrice.innerText = `${packages[i].priceUnit} ${
				variant?.previousPrice ? variant.previousPrice : previousPrice
			}`;
			return;
		} else if (sliderValue < Number(packages[i].packageQty)) {
			Q2 = Number(packages[i].packageQty);
			P2 = packagePrice;
			oldP2 = previousPrice;
			break;
		}
		Q1 = Number(packages[i].packageQty);
		P1 = packagePrice;
		oldP1 = previousPrice;
	}
	if (Q1 === null) {
		sliderPackagePrice.innerText = `${packages[0].priceUnit} ${P2}`;
		sliderPrevPrice.innerText = `${packages[0].priceUnit} ${oldP2}`;
	} else if (Q2 === null) {
		sliderPackagePrice.innerText = `${
			packages[packages.length - 1].priceUnit
		} ${P1}`;
		sliderPrevPrice.innerText = `${
			packages[packages.length - 1].priceUnit
		} ${oldP1}`;
	} else {
		const currentPrice = P1 + ((sliderValue - Q1) / (Q2 - Q1)) * (P2 - P1);
		const previousPrice =
			oldP1 + ((sliderValue - Q1) / (Q2 - Q1)) * (oldP2 - oldP1);
		sliderPackagePrice.innerText = `${
			packages[0].priceUnit
		} ${currentPrice.toFixed(2)}`;
		sliderPrevPrice.innerText = `${
			packages[0].priceUnit
		} ${previousPrice.toFixed(2)}`;
	}
}
function updateSliderData(slider, newSliderData, newPackageData) {
	const sliderInfo = slider.id.split("-");
	slider.sliderData = newSliderData;
	slider.removeEventListener("input", slider.inputEventListener);
	slider.inputEventListener = () =>
		updateSliderValue(
			slider,
			slider.sliderData,
			newPackageData,
			sliderInfo,
			true
		);
	slider.addEventListener("input", slider.inputEventListener);
}

$(document).on("change", ".duration-radio", function () {
	const slider = $(this).closest(".service").find(".slider")[0];
	let serviceLImit=$(this).closest(".service").find('.service-limit');
	let value = $(this).val();
	let id = slider.id.split("-");
	let subCatData = all_packages[id[0]][id[2]];
	if(Number(slider.value)>0){
		serviceLImit.text(subCatData.set_limit);
		let variants=all_packages[id[0]][id[2]]?.packages[Number(slider.value)-1]?.variants;
		if(variants){
			for(let k of variants){
				if(k.variant_name==value){
					if(k.variant_limit){
						serviceLImit.text(k.variant_limit);
					}
					break;
				}
			}
		}
	}
	$(this).closest(".durations")?.next()?.find("span")?.text(value);
	updateSliderValue(
		slider,
		subCatData,
		subCatData.packages[0],
		id,
		true,
		false
	);
});

function updateSliderBackground(slider) {
	const value = ((slider.value - slider.min) / (slider.max - slider.min)) * 100;
	let color;
	const colorMap = {
		"instagram-slider": "#C1337D",
		"twitter-slider": "#1DA1F2",
		"facebook-slider": "#1877F2",
		"tiktok-slider": "#E41D76",
		"youtube-slider": "#CD201F",
		"threads-slider": "#3F3838",
	};
	for (const [className, colorValue] of Object.entries(colorMap)) {
		if (slider.classList.contains(className)) {
			color = colorValue;
			break;
		}
	}
	slider.style.background = `linear-gradient(to right, ${color} ${value}%, #EFEFEF ${value}%)`;
}

function updateSliderValue(
	slider,
	sliderData,
	packageData,
	sliderInfo,
	changedByUser,
	flag = true
) {
	let sliderValueNum = 0;
	if (slider.value != 0) {
		let sliderValueIndex = Number(slider.value) - 1;
		let packages = sliderData.packages.sort(
			(a, b) => a.packageQty - b.packageQty
		);
		sliderValueNum = Number(packages[sliderValueIndex].packageQty);
		let service = slider.closest(".service");
		if (flag) {
			let durations = service.querySelector(".durations");
			if (
				packages[sliderValueIndex]?.variants &&
				packages[sliderValueIndex].variants?.length &&
				durations
			) {
				let variants = packages[sliderValueIndex].variants;
				if (slider.id.includes("livestream")) {
					variants =
						variants?.sort((a, b) => {
							return Number(a.duration) - Number(b.duration);
						}) || [];
				}
				let durationRadioArray = [];
				let alReadySelected = durations.querySelector(
					".duration-radio:checked"
				)?.value;
				if (alReadySelected !== undefined || alReadySelected) {
					let some = variants.some((e) => {
						return e.duration == alReadySelected;
					});
					if (!some) {
						alReadySelected = undefined;
					}
				}
				let f = false;
				for (let k in variants) {
					if (alReadySelected == variants[k].duration) {
						f = true;
					}
					durations.innerHTML = "";
					durationRadioArray.push(`<label class="duration-radio-label flex gap-3 bg-[#D6AEC3] cursor-pointer py-1 px-4 text-neutral-600 text-sm heading_table rounded-md has-bg-${
						sliderInfo[0]
					} has-[:checked]:text-white snap-start flex-shrink-0">
				${
					!slider.id.includes("livestream")
						? `<img class='h-7 rounded' src="${BASE_URL}assets/images/${variants[k].duration}.png" alt="${variants[k].duration}">`
						: ""
				}
			<input id="${sliderInfo[0]}-${variants[k].variant_id}-duration" ${
						(alReadySelected == variants[k].duration && "checked") ||
						(alReadySelected == undefined && k == 0 && "checked")
					} class="duration-radio hidden" name="${
						slider.id
					}-duration}" type="radio" value="${
						variants[k].duration
					}" autocomplete="off">
			${slider.id.includes("livestream") ? variants[k].duration : ""}</label>`);
				}
				durations.innerHTML = durationRadioArray.join("");
				if (!f) {
					durations.nextElementSibling.querySelector("span").innerText =
						variants[0].duration;
				}
			} else if (durations) {
				durations.innerHTML = "";
			}
		}
	}

	let arrows = slider.closest(".service").querySelector(".post-arrows");
	let svg;
	if (arrows) {
		svg = arrows.querySelector(".transition-transform.duration-300.-rotate-90");
	}
	if (sliderValueNum > 0) {
		slider?.previousElementSibling.classList.add("hidden");
	} else {
		slider?.previousElementSibling.classList.remove("hidden");
	}
	if (changedByUser && sliderValueNum > 0) {
		if (arrows) {
			if (!svg && sliderValueNum > 0) {
				arrows.click();
			}
		}
	} else if (changedByUser) {
		if (arrows) {
			if (svg && sliderValueNum == 0) {
				arrows.click();
			}
		}
	}
	let service = slider.variant ? slider.variant : sliderInfo[2];
	const sliderValue = document.getElementById(slider.id + "-value");
	const sliderPrevPrice = document.getElementById(slider.id + "-previousPrice");
	const sliderPackagePrice = document.getElementById(
		slider.id + "-packagePrice"
	);
	const indicator = document.getElementById(slider.id + "-selection-indicator");
	if (sliderValue) {
		sliderValue.textContent = sliderValueNum;
	} else {
		sliderValue.textContent = 0;
	}
	let variant = null;
	const checkedVariantRadio = slider
		?.closest(".service")
		?.querySelector(".durations")
		?.querySelector(".duration-radio:checked");
	if (checkedVariantRadio) {
		variant = {
			id: checkedVariantRadio.id.split("-")[1],
			duration: checkedVariantRadio.value,
		};
	}

	calculatePrice(
		sliderData.packages,
		sliderValueNum,
		sliderPrevPrice,
		sliderPackagePrice,
		slider
	);
	updateSliderBackground(slider);
	updateCartData(
		packageData.category_name,
		service,
		sliderValueNum,
		null,
		variant
	);

	if (indicator) {
		let service = slider.closest(".service");
		const linkInputs = service.querySelector(".link-inputs");
		let switchButton = service.querySelector(`.${sliderInfo[0]}-video-check`);
		if (
			(linkInputs && !switchButton) ||
			(linkInputs && switchButton && switchButton.checked == true)
		) {
			if (switchButton && switchButton?.checked == true) {
				service
					.querySelector(`.${sliderInfo[0]}-posts-container`)
					?.classList.add("hidden");
			}
			if (switchButton) {
				updateImageSelection(
					slider,
					sliderInfo,
					packageData,
					indicator,
					0,
					false
				);
			}
			updateLinkInputs(
				slider,
				sliderInfo,
				linkInputs,
				indicator,
				sliderValueNum
			);
		} else {
			service
				.querySelector(`.${sliderInfo[0]}-posts-container`)
				?.classList.remove("hidden");
			if (switchButton) {
				updateLinkInputs(slider, sliderInfo, linkInputs, indicator, 0, false);
			}
			updateImageSelection(
				slider,
				sliderInfo,
				packageData,
				indicator,
				sliderValueNum
			);
		}
	}
	if (sliderInfo[2] === "Comments~comments") {
		const commentTypeInputs = slider
			.closest(".service")
			.querySelectorAll(".comment-type input[type='checkbox']");
		commentTypeInputs.forEach((input) => {
			input.checked = false;
			input.dispatchEvent(new Event("change", { bubbles: true }));
		});
	}
}
function updateLinkInputs(
	slider,
	sliderInfo,
	linkInputs,
	indicator,
	sliderValueNum,
	flag = true
) {
	const cat = sliderInfo[0];
	const service = sliderInfo[2];
	const parentElement = slider.closest(".service");
	let limit = all_packages[sliderInfo[0]][sliderInfo[2]].set_limit;
 	 let service_limit=parentElement.querySelector('.service-limit');
	let postReactions = [];
	if (slider.variant) {
		limit =
			all_packages[sliderInfo[0]][sliderInfo[2]].subpackages[slider.variant]
				.set_limit;
	}
	let value = slider.value;
	let variants =
		all_packages[sliderInfo[0]][sliderInfo[2]]?.packages[Number(value) - 1]
			?.variants;
	if (variants) {
		let checkedRadio = parentElement?.querySelector(".duration-radio:checked");
		if (checkedRadio) {
			let checkedValue = checkedRadio.value;
			for (let k of variants) {
				if (k.variant_name == checkedValue) {
					if(k.variant_limit){
						limit = Number(k.variant_limit);
					}
					break;
				}
			}
		}
	}
	service_limit.innerText=limit;
	if (sliderValueNum > 0) {
		let currentPackage = all_packages[sliderInfo[0]][
			sliderInfo[2]
		].packages.find((e) => {
			return sliderValueNum == Number(e.packageQty);
		});
		postReactions = JSON.parse(currentPackage?.reactions || "[]");
	}
	let inputFields = Array.from(
		parentElement.querySelectorAll(".link-input-wrapper")
	);
	const clearFirstInputField = () => {
		const firstInputField = inputFields[0];
		if (firstInputField) {
			firstInputField.querySelector("input[type='text']").value = "";
			let reactionsDiv = firstInputField.querySelector(".reactions");
			if (reactionsDiv) {
				reactionsDiv.innerHTML = "";
			}
		}
	};
	const updateInputFields = (maxFields) => {
		inputFields.slice(maxFields).forEach((inputField) => {
			inputField.remove();
		});
		inputFields = inputFields.slice(0, maxFields);
		const perPostValue = Math.floor(sliderValueNum / inputFields.length);
		let remainingValue = sliderValueNum % inputFields.length;
		inputFields.forEach((inputField, index) => {
			const value = perPostValue + (remainingValue-- > 0 ? 1 : 0);
			const perPostIndicator = inputField.querySelector(".per-post-val span");
			if (perPostIndicator) {
				perPostIndicator.textContent = value;
			}
			let durations = inputField.querySelector(".reactions");
			if ((!postReactions || postReactions.length == 0) && durations) {
				durations.innerHTML = "";
			} else if (durations) {
				let htmlArray = [];
				postReactions.forEach((e) => {
					htmlArray.push(
						`<label class="checkbox-label gap-3 ${cat}-reaction flex reaction-radio items-center  opacity-60 cursor-pointer py-1 px-2 text-neutral-600 text-sm heading_table rounded-md-1 has-[:checked]:opacity-100 bg-${cat} has-[:checked]:gap-2 has-[:checked]:text-white snap-start flex-shrink-0">
								<img src='${BASE_URL}assets/images/${e.reaction}-reaction.svg'/>
								<span class='reaction-count text-white hidden'></span>
									<div class='w-[18px] h-[18px] relative'>
										<div class="cbx1 w-[18px] h-[18px] absolute">
											<input class="reaction"  name='${e.id}' value='${e.reaction}' type="checkbox">
											<label></label>
											<svg width="14" height="13" viewBox="0 0 15 14" fill="none">
												<path d="M2 8.36364L6.23077 12L13 2"></path>
											</svg>
										</div>
									</div>
							</label>`
					);
				});
				durations.innerHTML = htmlArray.join("");
				durations.querySelectorAll("input")[0].click();
				durations.scrollTo({
					left: 0,
					behavior: "smooth",
				});
			}
		});
	};
	if (sliderValueNum < Number(limit)) {
		clearFirstInputField();
		linkInputs.parentElement.classList.add("hidden");
		if (sliderValueNum == 0) {
			for (let i = 1; i < inputFields.length; i++) {
				inputFields[i].remove();
			}
		}
	} else {
		linkInputs.parentElement.classList.remove("hidden");
		const maxFields = Math.floor(sliderValueNum / limit);
		updateInputFields(maxFields);
	}
	let postsSelected = inputFields.map((inputField) => ({
		id: inputField.id,
		value: parseInt(
			inputField.querySelector(".per-post-val span").textContent,
			10
		),
	}));
	const existingPosts = cartData[cat]?.[service]?.postsSelected || [];
	postsSelected = postsSelected.map((newPost) => {
		const existingPost = existingPosts.find((post) => post.id === newPost.id);
		return existingPost
			? { ...newPost, comments: existingPost.comments }
			: newPost;
	});
	const input = inputFields[0].querySelector("input[type='text']");
	const siblings = document.querySelectorAll(`[name='${input.name}']`);
	if (indicator) {
		const nonEmptySiblings = Array.from(siblings).filter(
			(sibling) => sibling.value !== ""
		);
		indicator.querySelector(".selection-quantity").textContent =
			nonEmptySiblings.length;
	}
	if (flag) {
		updateCartData(cat, service, sliderValueNum, postsSelected, null);
	}
	expandAccordion(linkInputs.closest(".accordion"));
}
function updateImageSelection(
	slider,
	sliderInfo,
	packageData,
	indicator,
	sliderValueNum,
	flag = true
) {
	const parentElement = slider.closest(".service");
	let service_limit=parentElement.querySelector('.service-limit');
	const service = slider.variant || sliderInfo[2];
	let limit = all_packages[sliderInfo[0]][sliderInfo[2]].set_limit;
	if (slider.variant) {
		limit =
			all_packages[sliderInfo[0]][sliderInfo[2]].subpackages[slider.variant]
				.set_limit;
	}
	let value = slider.value;
	let variants =
		all_packages[sliderInfo[0]][sliderInfo[2]]?.packages[Number(value) - 1]
			?.variants;
	if (variants) {
		let checkedRadio = parentElement.querySelector(".duration-radio:checked");
		if (checkedRadio) {
			let checkedValue = checkedRadio.value;
			for (let k of variants) {
				if (k.variant_name == checkedValue) {
					if(k.variant_limit){
						limit = Number(k.variant_limit);
					}
					break;
				}
			}
		}
	}
	service_limit.innerText=limit;
	// if (sliderValueNum > 0) {
	// 	let currentPackage = all_packages[sliderInfo[0]][
	// 		sliderInfo[2]
	// 	].packages.find((e) => {
	// 		return sliderValueNum == Number(e.packageQty);
	// 	});
	// }
	const maxSelectableImages = Math.floor(sliderValueNum / limit);
	let selectedImages = Array.from(
		parentElement.querySelectorAll(".selectable-image.selected")
	);
	selectedImages.slice(maxSelectableImages).forEach((img) => {
		img.classList.remove("selected");
		img.nextElementSibling.textContent = "";
	});
	selectedImages = selectedImages.slice(0, maxSelectableImages);
	const totalQuantity = sliderValueNum;
	const baseQuantityPerImage = Math.floor(
		totalQuantity / selectedImages.length
	);
	let remainingQuantity = totalQuantity % selectedImages.length;
	selectedImages.forEach((img) => {
		img.nextElementSibling.textContent = `${
			baseQuantityPerImage + (remainingQuantity-- > 0 ? 1 : 0)
		}`;
	});
	let postsSelected = selectedImages.map((img) => ({
		id: img.id,
		value: parseInt(img.nextElementSibling.textContent, 10),
	}));
	const existingPosts =
		cartData[packageData.category_name]?.[sliderInfo[2]]?.postsSelected || [];
	postsSelected = postsSelected.map((newPost) => {
		const existingPost = existingPosts.find((post) => post.id === newPost.id);
		return existingPost
			? { ...newPost, comments: existingPost.comments }
			: newPost;
	});
	if (indicator) {
		indicator.querySelector(".selection-quantity").textContent =
			selectedImages.length;
	}
	let service2 = service == sliderInfo[2] ? null : sliderInfo[2];
	if (flag) {
		updateCartData(
			packageData.category_name,
			service,
			sliderValueNum,
			postsSelected,
			null,
			service2
		);
	}
	if (sliderInfo[2] === "Comments~comments") {
		const cat = sliderInfo[0];
		const categoryCommentsDiv = document.getElementById(`${cat}-comments`);
		categoryCommentsDiv.innerHTML = "";
		if (selectedImages.length > 0) {
			categoryCommentsDiv.parentElement.classList.remove("hidden");
		} else {
			categoryCommentsDiv.parentElement.classList.add("hidden");
		}
		for (const image of selectedImages) {
			const id = image.id;
			const imgElement = document.getElementById(id);
			let imgSrc =
				imgElement.getAttribute("data-image") || imgElement.getAttribute("src");
			if (cat == "instagram") {
				imgSrc = BASE_URL + "proxy/image?url=" + encodeURIComponent(imgSrc);
			}

			categoryCommentsDiv.innerHTML += `
			<div id="${cat}/${id}/comments" class="post-comments">
					<div class="flex justify-center mb-2 mt-6">
						<img class="h-[60px] w-[60px] object-cover rounded-full select-none" src="${imgSrc}">
					</div>
					<div class="flex flex-col xl:flex-row justify-center items-center gap-2 2xl:gap-4">
						<label
							class="comment-type cursor-pointer relative w-52 px-2 py-3 rounded-md has-[:checked]:border-instagram-checkbox block shadow-custom">
							<div
								class="rounded-full bg-gray-600 italic leading-3 font-bold text-white peer absolute top-1 right-1 w-4 h-4 text-xs text-center">
								i</div>
							<p
								class="absolute pointer-events-none top-3/4 right-0 bg-gray-500 text-white text-xs p-2 w-32 rounded opacity-0 peer-hover:opacity-100 z-10 transition-opacity duration-300">
								Pick unique, predefined comments based on your requirement
							</p>
							<h4 class="heading text-center text-md">Easy Content</h4>
							<input id="${cat}/${id}/easyContent" name="${cat}/${id}" type="checkbox" class="hidden">
						</label>
						<label
							class="comment-type cursor-pointer relative w-52 px-2 py-3 rounded-md has-[:checked]:border-instagram-checkbox block shadow-custom">
							<div
								class="rounded-full bg-gray-600 italic leading-3 font-bold text-white peer absolute top-1 right-1 w-4 h-4 text-xs text-center">
								i</div>
							<p
								class="absolute pointer-events-none top-3/4 right-0 bg-gray-500 text-white text-xs p-2 w-32 rounded opacity-0 peer-hover:opacity-100 z-10 transition-opacity duration-300">
								Leverage AI tech to automatically identify emotions</p>
							<h4 class="heading text-center text-md">AI Comments</h4>
							<input id="${cat}/${id}/aiComments" name="${cat}/${id}" type="checkbox" class="hidden">
						</label>
						<label
							class="comment-type cursor-pointer relative w-52 px-2 py-3 rounded-md has-[:checked]:border-instagram-checkbox block shadow-custom">
							<div
								class="rounded-full bg-gray-600 italic leading-3 font-bold text-white peer absolute top-1 right-1 w-4 h-4 text-xs text-center">
								i</div>
							<p
								class="absolute pointer-events-none top-3/4 right-0 bg-gray-500 text-white text-xs p-2 w-32 rounded opacity-0 peer-hover:opacity-100 z-10 transition-opacity duration-300">
								Your own customized comments</p>
							<h4 class="heading text-center text-md">Custom Comments</h4>
							<input id="${cat}/${id}/customComments" name="${cat}/${id}" type="checkbox" class="hidden">
						</label>
					</div>
					<div id="${cat}/${id}/comments-selection" class="comments-selection w-full"></div>
				</div>
				`;
		}
		expandAccordion(document.getElementById(`accordion-${sliderInfo[0]}`));
	}
}
function handlePostArrowsClick(indicator, details) {
	$(indicator)
		.find(".post-arrows")
		.on("click", function () {
			$(this).find("svg").toggleClass("-rotate-90");
			details.classList.toggle("hidden");
			expandAccordion(details.closest(".accordion"));
		});
}
function handleImageClick(images, slider, sliderInfo, indicator, packageData) {
	images?.addEventListener("click", function (e) {
		const parentElement = slider.closest(".service");
		let service_limit=parentElement.querySelector('.service-limit');
		const checkedVariant = slider
			.closest(".service")
			.querySelector(".variant-radio:checked");
		if (e.target && e.target.tagName === "IMG") {
			if (slider.value === "0") {
				createToast("error", "Please select a quantity first.");
				return;
			}
			let packages = [];
			let limit = 0;
			if (checkedVariant) {
				let service2 = checkedVariant.id.split("-")[2];
				packages = all_packages[sliderInfo[0]][sliderInfo[2]].subpackages[
					service2
				].packages.sort((a, b) => a.packageQty - b.packageQty);
				limit =
					all_packages[sliderInfo[0]][sliderInfo[2]].subpackages[service2]
						.set_limit;
			} else {
				packages = all_packages[sliderInfo[0]][sliderInfo[2]].packages.sort(
					(a, b) => a.packageQty - b.packageQty
				);
				limit = all_packages[sliderInfo[0]][sliderInfo[2]].set_limit;
			}
			let value = slider.value;
			let variants =
				all_packages[sliderInfo[0]][sliderInfo[2]]?.packages[Number(value) - 1]
					?.variants;
			if (variants) {
				let checkedRadio = parentElement.querySelector(
					".duration-radio:checked"
				);
				if (checkedRadio) {
					let checkedValue = checkedRadio.value;
					for (let k of variants) {
						if (k.variant_name == checkedValue) {
							if(k.variant_limit){
								limit = Number(k.variant_limit);
							}
							break;
						}
					}
				}
			}
			service_limit.innerText=limit;
			let sliderValue = Number(packages[Number(slider.value) - 1].packageQty);
			const target = e.target;
			const maxSelectableImages = Math.floor(sliderValue / limit);
			let selectedImages = parentElement.querySelectorAll(
				".selectable-image.selected"
			);
			let numSelectedImages = selectedImages?.length;
			if (target.classList.contains("selected")) {
				target.classList.remove("selected");
				target.nextElementSibling.textContent = "";
				numSelectedImages--;
			} else if (numSelectedImages < maxSelectableImages) {
				target.classList.add("selected");
				numSelectedImages++;
			} else {
				debouncedToast("error", `Minimum quantity per post is ${limit}.`);
				return;
			}
			selectedImages = parentElement.querySelectorAll(
				".selectable-image.selected"
			);
			indicator.querySelector(".selection-quantity").textContent =
				numSelectedImages;
			updateImageSelection(
				slider,
				sliderInfo,
				packageData,
				indicator,
				sliderValue,
				limit
			);
		}
	});
}
function handleLinkInput(input) {
	const name = input.name.split("-");
	const cat = name[3];
	const service = name[4];
	let InputService = input.closest(".service");
	const slider = InputService.querySelector('input[type="range"]');
	let variant = slider.variant;
	let reactionFlag = input
		.closest(".link-input-wrapper")
		.querySelector(".reactions");
	const serviceType = slider.id.split("-")[2];
	let sliderValue = Number(slider.value);
	if (sliderValue > 0) {
		let packages = variant
			? all_packages[cat][serviceType].subpackages[variant].packages.sort(
					(a, b) => a.quantity - b.quantity
			  )
			: all_packages[cat][serviceType].packages.sort(
					(a, b) => a.quantity - b.quantity
			  );
		sliderValue = Number(packages[sliderValue - 1].packageQty);
	}
	const siblings = document.querySelectorAll(`[name='${input.name}']`);
	const indicator = document.getElementById(`${slider.id}-selection-indicator`);
	if (indicator) {
		const nonEmptySiblings = Array.from(siblings).filter(
			(sibling) => sibling.value !== ""
		);
		indicator.querySelector(".selection-quantity").textContent =
			nonEmptySiblings.length;
	}
	const postsSelected = Array.from(siblings).map((sibling) => {
		const perPostValue = sibling
			.closest(".link-input-wrapper")
			.querySelector(".per-post-val span");
		let reactions = undefined;
		if (reactionFlag) {
			let reactionArray = [
				...sibling
					.closest(".link-input-wrapper")
					.querySelector(".reactions")
					.querySelectorAll('input[type="checkbox"]:checked'),
			];
			if (reactionArray.length) {
				reactions = {};
			}
			reactionArray.forEach((e) => {
				let id = e.name;
				let count = e
					.closest("label")
					.querySelector(".reaction-count").innerText;
				reactions[id] = count;
			});
		}
		return {
			id: sibling.value,
			value: Number(perPostValue.textContent),
			reactions,
		};
	});
	updateCartData(cat, serviceType, sliderValue, postsSelected);
}
const linkInputsContainer = document.querySelectorAll(".link-inputs");
linkInputsContainer.forEach((container) => {
	container.addEventListener("input", function (event) {
		const elem = event.target;
		if (elem.classList.contains("link-input")) {
			handleLinkInput(elem);
		}
	});
});
sliders.forEach((slider) => {
	const details = document.getElementById(slider.id + "-detail");
	const indicator = document.getElementById(slider.id + "-selection-indicator");
	const sliderInfo = slider.id.split("-");
	const sliderData = all_packages[sliderInfo[0]][sliderInfo[2]];
	const packageData = sliderData.packages.find(
		(pkg) =>
			pkg.category_name === sliderInfo[0] &&
			pkg.serviceType === sliderInfo[2].split("~")[1]
	);
	slider.setAttribute("min", 0);
	slider.setAttribute("max", sliderData?.packages.length);
	setBreakpoints(
		slider,
		sliderInfo,
		0,
		sliderData.packages.length,
		sliderData?.packages
	);
	const images = slider
		.closest(".service")
		.querySelector("." + sliderInfo[0] + "-posts-container");
	handlePostArrowsClick(indicator, details);
	handleImageClick(images, slider, sliderInfo, indicator, packageData);
	slider.sliderData = sliderData;
	slider.inputEventListener = () =>
		updateSliderValue(slider, sliderData, packageData, sliderInfo, true);
	slider.addEventListener("input", slider.inputEventListener);
});
function setBreakpoints(slider, sliderInfo, minQty, maxQty, packages = []) {
	packages = packages.sort((a, b) => a.packageQty - b.packageQty);
	packages = [
		{
			packageQty: 0,
		},
		...packages,
	];
	const breakpointsDiv = $(`#${CSS.escape(slider.id)}-breakpoints`);
	const numBreakpoints = packages.length;
	const range = maxQty - minQty;
	const breakpoints = Array.from(
		{ length: numBreakpoints },
		(_, i) => minQty + (i * range) / (numBreakpoints - 1)
	);
	breakpointsDiv.html("");
	breakpoints.forEach((breakpoint, index) => {
		const leftPosition = (breakpoint / maxQty) * 100;
		const distanceFromCenter = Math.abs(leftPosition - 50);
		const adjustmentFactor = distanceFromCenter / 60;
		const adjustedLeftPosition =
			leftPosition + (leftPosition < 50 ? adjustmentFactor : -adjustmentFactor);
		let qty = Number(packages[index].packageQty);
		const arrow = $("<div>")
			.addClass(
				`arrow absolute text-xs text-${sliderInfo[0]} select-none -translate-x-1/2 cursor-pointer`
			)
			.css({
				left: `${adjustedLeftPosition}%`,
			})
			.html(qty)
			.on("click", function () {
				if (slider.disabled == true) return;
				slider.value = index;
				slider.dispatchEvent(new Event("input"));
			});
		breakpointsDiv.append(arrow);
	});
}
function getImageDataUrl(imgElement) {
	const canvas = document.createElement("canvas");
	canvas.width = imgElement.naturalWidth;
	canvas.height = imgElement.naturalHeight;
	const ctx = canvas.getContext("2d");
	ctx.drawImage(imgElement, 0, 0);
	return canvas.toDataURL("image/jpeg");
}
let toastVisible = false;
function debouncedToast(type, message) {
	if (!toastVisible) {
		toastVisible = true;
		createToast(type, message);
		setTimeout(() => {
			toastVisible = false;
		}, 1000);
	}
}
function unChangerUserName(element1, element2) {
	element1.style.display = "none";
	element2.style.display = "flex";
}

const changeButtons = document.querySelectorAll(".change-button");
changeButtons.forEach((button) => {
	button.addEventListener("click", async function () {
		const cart = typeof cartData !== "undefined" ? cartData : {};
		let activeTabId = button.getAttribute("data");
		const hasFilledCart = Object.keys(cart[activeTabId] || {}).length > 1;
		if (
			hasFilledCart &&
			!(await showDialogBox(
				"Are you sure you want to change the user? Your cart data for " +
					activeTabId +
					" will be lost."
			))
		) {
			return;
		}
		const activeMode = button.closest(".active-mode");
		const changeMode = activeMode.nextElementSibling;
		if (changeMode && changeMode.classList.contains("change-mode")) {
			changeMode.style.display = "flex";
			let user_name =
				document
					.querySelector(`.${activeTabId}-user-id`)
					?.textContent?.trim() || "";
			if (user_name?.trim().length) {
				if (user_name[0] == "@") {
					user_name = user_name?.trim()?.slice(1);
				}
				if (!cartData[activeTabId]) {
					cartData[activeTabId] = {
						u_name: user_name,
					};
				}
			}
			let curentInput = changeMode.querySelector("input");
			curentInput.focus();
			curentInput.value = user_name;
			activeMode.style.display = "none";
			expandAccordion(changeMode.closest(".accordion"));
		}
	});
});

let windowReady = false;
window.addEventListener("load", function () {
	windowReady = true;
});

function serviceController(current, cartFlag) {
	//the function thats help in controlling of the user
	let currentService = document.querySelector(`.${current}-services`);
	let allServicesArray = [
		...currentService.querySelectorAll(".service:not(.hidden)"),
	];
	if (cartFlag) {
		let currentServiceUser = document
			.querySelector(`.${current}-user-id`)
			.innerHTML?.trim();
		if (!currentServiceUser) {
			let userInputChangeMode = document
				.querySelector(`.${current}-search`)
				.closest(".change-mode");
			createToast("error", `Please select a profile for ${current}`);
			userInputChangeMode.classList.add("shake");
			userInputChangeMode.scrollIntoView({
				behavior: "smooth",
				block: "center",
			});
			setTimeout(() => {
				userInputChangeMode.classList.remove("shake");
			}, 1000);
			return false;
		}
	}
	if (allServicesArray.length) {
		for (let i = 0; i < allServicesArray.length; i++) {
			let flag = false;
			let serviceValContainer =
				allServicesArray[i].querySelector(".slider-value");
			let serviceValue = serviceValContainer.innerHTML;
			if (!serviceValue || serviceValue == "0") {
				if (cartFlag && allServicesArray.length == 1) {
					let slider = allServicesArray[i].querySelector(".slider");
					slider.classList.add("shake");
					let text =
						serviceValContainer.nextElementSibling.innerText?.toLowerCase();
					createToast(
						"error",
						`Please select a quantity from  ${current} ${text}.`
					);
					allServicesArray[i].scrollIntoView({
						behavior: "smooth",
						block: "center",
					});
					setTimeout(() => {
						slider.classList.remove("shake");
					}, 1000);
					return false;
				}
				allServicesArray[i].classList.add("hidden");
				let id = allServicesArray[i].querySelector(".slider").id.split("-");
				let box = document.getElementById(`${id[0]}-${id[2]}-checkbox`);
				box.checked = false;
				box.dispatchEvent(new Event("change"));
				continue;
			}
			let servicePostsContainer = allServicesArray[i].querySelector(
				".selection-quantity"
			);
			let input = allServicesArray[i].querySelector("input[type='range']");
			let name = input.getAttribute("id").split("~")[1];
			let name1 =
				serviceValContainer.nextElementSibling.innerText.toLowerCase();
			if (servicePostsContainer && flag == false) {
				let value = servicePostsContainer.innerHTML;
				if (value == 0 || value == "" || !value) {
					flag = 2;
				}
				let checked = allServicesArray[i].querySelector(".post-input-check");
				if (
					(!cartFlag && !checked) ||
					(!cartFlag && checked && checked.checked)
				) {
					let validLinks = validateInputs(allServicesArray[i]);
					if (validLinks == false) {
						return false;
					} else {
						let reactionsContainers =
							allServicesArray[i].querySelectorAll(".reactions");
						if (reactionsContainers.length) {
							for (let i = 0; i < reactionsContainers.length; i++) {
								let reactionsDiv = reactionsContainers[i];
								if (reactionsDiv.innerHTML !== "") {
									let checkedReactions = [
										...reactionsDiv.querySelectorAll(
											'input[type="checkbox"]:checked'
										),
									];
									if (checkedReactions.length == 0) {
										reactionsDiv.scrollIntoView({
											behavior: "smooth",
											block: "center",
										});
										createToast(
											"error",
											"Please select at least one Facebook Post Likes reaction."
										);
										setTimeout(() => {
											reactionsDiv.classList.add("shake");
											setTimeout(() => {
												reactionsDiv.classList.remove("shake");
											}, 2000);
										}, 500);
										return false;
									}
								}
							}
						}
						flag = false;
					}
				}
			}
			if (flag) {
				createToast(
					"error",
					`Please select at least one post from ${current} ${name1}`
				);
				allServicesArray[i].scrollIntoView({
					behavior: "smooth",
					block: "nearest",
				});
				let imageContainer = allServicesArray[i].querySelector(
					`.${current}-posts-container`
				);
				if (imageContainer) {
					imageContainer.classList.add("shake");
					setTimeout(() => {
						imageContainer.classList.remove("shake");
					}, 1500);
				} else {
					let errorSlider = allServicesArray[i].querySelector(".slider");
					errorSlider.classList.add("shake");
					setTimeout(() => {
						errorSlider.classList.remove("shake");
					}, 1500);
				}
				return false;
			}
			if (name == "comments") {
				if (cartData[current]?.["Comments~comments"]) {
					for (const post of cartData[current]?.["Comments~comments"]
						?.postsSelected) {
						const commentsArray = (post.comments || "")
							.split("\n")
							.map((comment) => comment.trim())
							.filter((comment) => comment !== "");
						if (commentsArray.length !== post.value) {
							controlCommentsFlow(current, post.id);
							return false;
						}
					}
				}
			}
		}
	}
	return true;
}
$(".service-checkbox").on("change", function () {
	const checkboxId = this.id.split("-");
	const sliderId = `${checkboxId[0]}-slider-${checkboxId[1]}`;
	const slider = document.getElementById(sliderId);
	const accordion = slider.closest(".accordion");
	let current = $(".social-checkbox:checked")
		.closest("label")
		.find("h2")
		.text()
		.toLowerCase();
	if (this.checked) {
		if (windowReady) {
			let a = serviceController(current);
			if (!a) {
				this.checked = false;
				return false;
			}
		}
		slider.closest(".service").classList.remove("hidden");
		slider.scrollIntoView({ behavior: "smooth", block: "center" });
	} else {
		slider.value = 0;
		slider.dispatchEvent(new Event("input"));
		slider.closest(".service").classList.add("hidden");
	}
	const anyChecked = $(accordion).find(".service-checkbox:checked").length > 0;
	$(accordion)
		.find(".addToCart")
		.css("display", anyChecked ? "block" : "none");
	expandAccordion(accordion);
});

function addToCart(allCartData, addToCartButton) {
	const formData = new FormData();
	let arr = Object.keys(allCartData || {});
	if (arr.every((key) => Object.keys(allCartData[key]).length === 0)) {
		formData.append("emptyCart", true);
	}
	formData.append("cartData", JSON.stringify(allCartData));
	formData.append("act", "add-to-cart");
	formData.append(csrfName, csrfHash);
	$.ajax({
		url: BASE_URL + "cart-data/",
		type: "POST",
		data: formData,
		contentType: false,
		processData: false,
		success: function (responsedata) {
			var response = JSON.parse(responsedata);
			if (response.status == "success") {
				handleCartCounter(allCartData, addToCartButton);
				$(".summary_tabs").empty();
				$(".summary_tabs").html(response.html);
				$(".summary_tabs").removeClass("hidden");
				let id = $(".social-checkbox:checked").attr("id");
				if (addToCartButton) {
					let allCheckboxes = $(".summary_tabs").find(".summary-checkbox");
					allCheckboxes.each(function () {
						let summaryCheckboxId = $(this).attr("id").toLowerCase();
						if (summaryCheckboxId.includes(id)) {
							$(this).click();
						}
					});
				}
			}
			if (addToCartButton) {
				let message = response.message;
				if (message?.length) {
					message = message
						.split(" ")
						.map((e) => {
							return e[0].toUpperCase() + e.slice(1);
						})
						.join(" ");
				}
				createToast("success", message, true);
				addToCartButton.innerHTML = "Add To Cart";
				addToCartButton.disabled = false;
			}
		},
		error: function (error) {
			createToast("error", error);
			handleCartCounter(allCartData, addToCartButton);
			if (addToCartButton) {
				addToCartButton.innerHTML = "Add To Cart";
				addToCartButton.disabled = false;
			}
		},
	});
}
function handleCartCounter(allCartData, addToCartButton) {
	let counter = document.querySelector(".cart-counter");
	if (counter) {
		let count = 0;
		for (let k in allCartData) {
			count += Object.keys(allCartData[k]).length;
		}
		if (count > 0) {
			counter.classList.remove("hidden");
			counter.classList.add("flex");
			counter.innerHTML = count;
			if (addToCartButton) {
				window.scrollTo({
					top: 0,
					left: 0,
					behavior: "smooth",
				});
			}
		} else {
			counter.classList.remove("flex");
			counter.classList.add("hidden");
		}
	}
}

const leftArrows = document.querySelectorAll(".left-arrow");
const rightArrows = document.querySelectorAll(".right-arrow");
const scrollContainers = document.querySelectorAll(".snap-x");
function scrollContainer(container, direction) {
	const scrollAmount = Array.from(container.children)
		.find(
			(el) =>
				el.getBoundingClientRect().right >
				container.getBoundingClientRect().left
		)
		.getBoundingClientRect().width;
	container.scrollBy({
		left: scrollAmount * direction,
		behavior: "smooth",
	});
}
scrollContainers.forEach((container) => {
	container.addEventListener("wheel", function (event) {
		if (event.deltaY !== 0) {
			event.preventDefault();
			const direction = event.deltaY < 0 ? -1 : 1;
			scrollContainer(container, direction);
		}
	});
});
leftArrows.forEach((leftArrow) => {
	leftArrow.addEventListener("click", function () {
		const container = this.nextElementSibling;
		if (container && container.classList.contains("services-selector")) {
			scrollContainer(container, -1);
		}
	});
});
rightArrows.forEach((rightArrow) => {
	rightArrow.addEventListener("click", function () {
		const container = this.previousElementSibling;
		if (container && container.classList.contains("services-selector")) {
			scrollContainer(container, 1);
		}
	});
});
function handleCheckboxChange(checkbox) {
	const category = checkbox.id.split("-")[1];
	const summaryTab = document.querySelector(`.summary-tab-${category}`);
	if (checkbox.checked) {
		summaryTab.style.display = "block";
	} else {
		summaryTab.style.display = "none";
	}
}
$(document).on("click", ".service", function (event) {
	const slider = $(this).find(".slider");
	if (slider.prop("disabled")) {
		debouncedToast("error", "Please select a profile first.");
		const inputField = $(this).closest(".accordion").find(".change-mode");
		inputField.addClass("shake");
		setTimeout(() => {
			inputField.removeClass("shake");
		}, 500);
		inputField.find("input").focus();
	}
});
$(".variant-radio").on("change", function () {
	const id = $(this).attr("id");
	const [category, parent, service] = id.split("-");
	let limit = all_packages[category][parent].set_limit;
	let subCatData = all_packages[category][parent]?.subpackages;
	if (subCatData && subCatData.hasOwnProperty(service)) {
		subCatData = subCatData[service];
	}
	if (service == "shortviews~shortviews" && category == "youtube") {
		let service1 = $(this).closest(".service");
		let checked = $(this).is(":checked");
		let images = service1.find(".image-wrapper");
		let flag = false;
		if (checked) {
			images.each(function () {
				let img = $(this);
				if (img.hasClass("shortViews")) {
					img.removeClass("hidden");
					flag = true;
				} else {
					img.addClass("hidden");
				}
			});
			if (!flag) {
				service1
					.find(`.${category}-posts-container`)
					.find(".text-gray-500")
					?.remove();
				service1
					.find(`.${category}-posts-container`)
					.append(
						'<p class="text-center w-full pt-3 text-gray-500">Account has no short videos.</p>'
					);
			} else {
				service1
					.find(`.${category}-posts-container`)
					.find(".text-gray-500")
					?.remove();
			}
		} else {
			images.each(function () {
				let img = $(this);
				if (img.hasClass("shortViews")) {
					img.addClass("hidden");
				} else {
					flag = true;
					img.removeClass("hidden");
				}
			});
			if (!flag) {
				service1
					.find(`.${category}-posts-container`)
					.find(".text-gray-500")
					?.remove();
				service1
					.find(`.${category}-posts-container`)
					.append(
						'<p class="text-center w-full pt-3 text-gray-500">Account has no videos.</p>'
					);
			} else {
				service1
					.find(`.${category}-posts-container`)
					.find(".text-gray-500")
					?.remove();
			}
		}
	}
	const label = $(`[id='${category}-slider-${parent}-value']`).next();
	const slider = $(`[id='${category}-slider-${parent}']`)[0];
	let minimumValueContainer = slider
		.closest(".service")
		.querySelector(".note-minimum");
	slider.value = 0;
	slider.dispatchEvent(new Event("input"));
	var title;
	if ($(this).prop("checked")) {
		limit = all_packages[category][parent]?.subpackages[service].set_limit;
		let elem = $(this);
		let siblings = $(this)
			.closest("label")
			.closest("div")
			.find(".variant-radio");
		siblings?.each(function (index, element) {
			if ($(element).is(elem)) return;
			if (
				$(element).attr("id")?.includes("shortviews~shortviews") &&
				category == "youtube" &&
				$(element).prop("checked") == true
			) {
				let service1 = $(element).closest(".service");
				let images = service1.find(".image-wrapper");
				images.each(function () {
					let img = $(this);
					if (img.hasClass("shortViews")) {
						img.addClass("hidden");
					} else {
						img.removeClass("hidden");
					}
				});
			}
			$(element).prop("checked", false);
		});
		$(this).prop("checked", true);
		title = id.split("-")[2].split("~")[0];
		slider.variant = `${service}`;
	} else {
		subCatData = all_packages[category][parent];
		title = id.split("-")[1].split("~")[0];
		slider.variant = null;
	}
	if (minimumValueContainer) {
		let serviceNameContainer =
			minimumValueContainer.querySelector(".service-name");
		let serviceLimitContainer =
			minimumValueContainer.querySelector(".service-limit");
		serviceLimitContainer.innerHTML = limit;
		serviceNameContainer.innerHTML = title;
	}
	label.text(title);
	slider.max = subCatData.packages.length;
	const packageData = subCatData.packages[0];
	updateSliderData(slider, subCatData, packageData);
	setBreakpoints(
		slider,
		[category, parent, service],
		0,
		slider.max,
		subCatData.packages
	);
});

function addOnHandler(btn, act) {
	let parent;
	let freeServiceValue;
	if (act === "removeAddonData") {
		parent = $(btn).closest(".remove");
	} else if (act == "freebiesOnCart") {
		parent = $(btn).closest(".freebies");
		if ($(btn).text()?.trim() == "Added") return;
		let input = parent.find("input[name='freeService']")[0];
		let flag = input.classList.contains("valid-input");
		freeServiceValue = input.value;
		if (!flag) {
			const event = new KeyboardEvent("keydown", {
				key: "Enter",
				keyCode: 13,
				code: "Enter",
				bubbles: true,
				cancelable: true,
			});
			input.dispatchEvent(event);
			return;
		}
	} else {
		parent = $(btn).closest(".addon");
	}
	const [category, serviceType, pkg_id] = parent.attr("id").split("-");
	const allData = {
		[csrfName]: csrfHash,
		serviceType,
		pkg_id,
		category,
		act,
		freeService: freeServiceValue,
	};
	$.ajax({
		url: BASE_URL + "cart-data/",
		type: "POST",
		data: allData,
		success: function (responsedata) {
			var response = JSON.parse(responsedata);
			if (response.status == "success") {
				if (act == "freebiesOnCart") {
					createToast("success", "Free service added successfully.");
				}
				var checkedCheckboxes = [];
				$(".summary-checkbox:checked").each(function () {
					checkedCheckboxes.push(this.id);
				});
				$(".summary_tabs").empty();
				$(".summary_tabs").html(response.html);
				checkedCheckboxes.forEach(function (checkboxId) {
					const checkbox = document.getElementById(checkboxId);
					if (checkbox) {
						checkbox.checked = true;
						handleCheckboxChange(checkbox);
					}
				});
			}
		},
		error: function (error) {
			createToast("error", error);
		},
	});
}

$(document).on("click", ".delete-summary", function () {
	const button = $(this);
	disableButton(button);
	const category = button.data("ctg");
	const service = button.data("attr");
	const allData = {
		category,
		service_data: service,
		[csrfName]: csrfHash,
	};
	$.ajax({
		url: BASE_URL + "remove-product/",
		type: "POST",
		data: allData,
		success: function (response) {
			handleSuccessResponse(response, button, category, service);
			let counter = document.querySelector(".cart-counter");
			if (counter) {
				let count = Number(counter.innerHTML?.trim() || 0);
				count -= 1;
				count = count < 0 ? 0 : count;
				if (count == 0) {
					counter.classList.remove("flex");
					counter.classList.add("hidden");
					counter.innerHTML = 0;
				} else {
					counter.classList.add("flex");
					counter.classList.remove("hidden");
					counter.innerHTML = count;
				}
			}
		},
		error: function (response) {
			enableButton(button);
		},
	});
});

function disableButton(button) {
	button.attr("disabled", true);
	button.css("opacity", "0.6");
}
function enableButton(button) {
	button.attr("disabled", false);
	button.css("opacity", "1");
}

function handleSuccessResponse(response, button, category, service) {
	response = JSON.parse(response);
	const hasDataInCart = Object.values(response.cart.cartItems).some((item) => {
		return Object.values(item).some((subItem) => {
			return (
				(typeof subItem === "object" && Object.keys(subItem).length > 0) ||
				(Array.isArray(subItem) && subItem.length > 0) ||
				subItem
			);
		});
	});
	if (!hasDataInCart) {
		$(".summary_tabs").addClass("hidden");
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		});
	}
	if (response.success) {
		updateSummary(button, category, service, response.cart || {});
	} else {
		enableButton(button);
		createToast("error", response.message);
	}
}
function updateSummary(button, category, service, response) {
	const szn = button.prev();
	const serviceSubtotal = document.querySelectorAll(".total-services-subtotal");
	const totalAddon = document.querySelectorAll(".total-addon-amount");
	const totalDiscount = document.querySelector(".total-discount");
	const totalSubTotal = document.querySelector(".total-subtotal");
	let value = Number(szn.text()?.split(" ")[1] || 0);
	let selectedService = getSelectedService(category, service);
	const summaryContainer = document.querySelector(".summary-cart-container");
	const valueContainer = summaryContainer.querySelector(`.text-${category}`);
	const sn2Child = valueContainer.children[1];
	const valueInSummary = Number(
		sn2Child.innerText.slice(1)?.split(",")?.join("") || 0
	);
	const totalSummaryAmountContainer = document.querySelectorAll(
		".total-summary-amount"
	);
	let summaryTotal = Number(
		totalSummaryAmountContainer[0].innerText
			.slice(1)
			.trim()
			?.split(",")
			?.join("")
	);
	const addOnArray = getAddOn(category, service);
	if (addOnArray.length) {
		updateAddOn(addOnArray.length == 2 ? addOnArray[1] : addOnArray[0]);
	}
	button.closest(".delete-summary-parent").remove();
	updateSummaryValues(
		sn2Child,
		valueInSummary,
		value,
		summaryTotal,
		category,
		valueContainer
	);
	summaryTotal = response.cart_total_service_amount;
	let totalAmount = Number(response.cart_price_paid);
	if (totalSubTotal) {
		totalSubTotal.innerText = `£ ${(
			summaryTotal + (response.cart_total_addon || 0)
		).toFixed(2)}`;
	}
	serviceSubtotal.forEach(function (e) {
		e.innerText = `£ ${summaryTotal}`;
	});
	if (response.cart_discount_price) {
		totalDiscount.innerText = `- £ ${Number(
			response.cart_discount_price
		).toFixed(2)}`;
	}
	if (response.cart_total_addon) {
		totalAddon.forEach(function (e) {
			e.innerText = `£ ${Number(response.cart_total_addon).toFixed(2)}`;
		});
	} else {
		if (totalAddon) {
			totalAddon.forEach(function (e) {
				e?.closest("div").remove();
			});
		}
	}
	if (response.cart_original_price) {
	}

	// if()
	updateTotalSummaryAmount(totalAmount);
	if (selectedService.checked) {
		selectedService.click();
	}
	let summary_tabs = document.querySelector(".summary_tabs");
	setTimeout(() => {
		summary_tabs.scrollIntoView({
			behavior: "smooth",
			block: "start",
		});
	}, 50);
}
function getSelectedService(category, service) {
	let selectedService = document.getElementById(
		`${category}-${service}-checkbox`
	);
	if (!selectedService) {
		const variantButton = document.querySelector(
			`[class*="${category}-"][class*="~${service.split("~")[1]}-variant"]`
		);
		const parent = variantButton.id.split("-")[1];
		selectedService = document.getElementById(`${category}-${parent}-checkbox`);
	}
	return selectedService;
}
function getAddOn(category, service) {
	const summary_tabs = document.querySelector(".summary_tabs");
	return summary_tabs.querySelectorAll(`[id^="${category}-${service}"]`);
}
function updateAddOn(addOn, value) {
	const directParent = addOn.parentElement;
	if (directParent && directParent.classList.contains("grid")) {
		addOn.remove();
	} else {
		const addOnValue = Number(
			addOn.querySelector("p").innerText.slice(1).trim()
		);
		value += addOnValue;
		value = value.toFixed(2);
		addOn.parentElement.remove();
	}
	return value;
}
function updateSummaryValues(
	sn2Child,
	valueInSummary,
	value,
	summaryTotal,
	category,
	valueContainer
) {
	if (valueInSummary == value) {
		valueContainer.remove();
		sn2Child.innerText = sn2Child.innerText.slice(0, 1) + "0.00";
		summaryTotal -= value;
		const btn = document.getElementById(
			`summary-${
				category.slice(0, 1).toUpperCase() + category.slice(1)
			}-checkbox`
		);
		btn.click();
		btn.closest("label").remove();
	} else if (valueInSummary > value) {
		sn2Child.innerText =
			sn2Child.innerText.slice(0, 1) + `${(valueInSummary - value).toFixed(2)}`;
		summaryTotal -= value;
	}
	return summaryTotal;
}

function updateTotalSummaryAmount(summaryTotal) {
	const totalSummaryAmountContainer = document.querySelectorAll(
		".total-summary-amount"
	);
	totalSummaryAmountContainer.forEach((e) => {
		e.innerText = `£ ${summaryTotal.toFixed(2)}`;
	});
}
function EventHandlingForSummary(event) {
	if (event.target.classList.contains("free-service-accordion-btn")) {
		let btn = event.target;
		let nextElement = btn.nextElementSibling;
		let svg = btn.querySelector("svg");
		if (btn.classList.contains("open")) {
			btn.classList.remove("open");
			svg.style.transform = "rotate(0deg)";
			nextElement.style.height = "0px";
			nextElement.classList.add("overflow-hidden");
			return;
		}
		svg.style.transform = "rotate(180deg)";
		btn.classList.add("open");
		nextElement.style.height = nextElement.scrollHeight + "px";
		nextElement.classList.remove("overflow-hidden");
	} else if (event.target.classList.contains("view-input")) {
		let button = event.target;
		let input = button.previousElementSibling;
		if (!checkInput(input)) {
			input.scrollIntoView({
				behavior: "smooth",
				block: "center",
			});
			setTimeout(() => {
				input.classList.add("shake");
				setTimeout(() => {
					input.classList.remove("shake");
				}, 2000);
			}, 500);
			return;
		}
		const inputValue = input.value;
		window.open(inputValue, "_blank");
	}
}
document.addEventListener("click", EventHandlingForSummary);
//this is the function to handle inputs which exsits in free state
$(document).on("keydown", ".freeServiceLinkData", function (e) {
	let nearestButton = $(this).closest("div")?.next();
	if (nearestButton.text()?.trim() == "Added") return;
	if (e.key === "Enter") {
		const freeServiceInput = $(this); // Get the current input element
		const freeServiceContainer = freeServiceInput.closest(".freebies");
		const link = freeServiceInput.val(); // Get the input value
		const button = freeServiceContainer.find(".freebies-add-button");
		const category = freeServiceContainer
			.attr("free-service-category")
			.toLowerCase();
		let serviceType = freeServiceContainer.attr("service-type").toLowerCase();
		switch (serviceType) {
			case "postlink":
				serviceType = "Post Link";
				break;
			case "profileLink":
				serviceType = "Profile Link";
				break;
			case "storylink":
				serviceType = "Story Link";
				break;
			case "channellink":
				serviceType = "Channel Link";
				break;
			case "videolink":
				serviceType = "Video Link";
				break;
			case "spacelistenerlink":
				serviceType = "Spacelistener Link";
				break;
			default:
				serviceType = "Profile Link";
				break;
		}
		let regexElement = `${category}${serviceType.split(" ").join("")}`;
		let pattern = regexMap[regexElement];
		let isValid = false;
		if (Array.isArray(pattern)) {
			for (let regex of pattern) {
				if (regex.test(link)) {
					isValid = true;
					break;
				}
			}
		} else if (pattern) {
			isValid = pattern.test(link);
		}

		if (isValid == false) {
			freeServiceContainer.addClass("shake");
			createToast(
				"error",
				`Please enter valid ${
					category[0].toUpperCase() + category.slice(1)
				} ${serviceType}`
			);
			setTimeout(() => {
				freeServiceContainer.removeClass("shake");
			}, 1000);
		} else {
			freeServiceInput.addClass("valid-input");
			button.click();
		}
	}
});

$(document).on("change", ".reaction", function () {
	let checkBox = $(this);
	let limit = Number(
		checkBox.closest(".service")?.find(".service-limit")?.text() || 0
	);
	let totalReactions = checkBox
		.closest(".reactions")
		.find('input[type="checkbox"]:checked');
	if (!checkBox.prop("checked")) {
		let reactionCount = $(this).closest("label").find(".reaction-count");
		reactionCount.addClass("hidden");
		reactionCount.text("");
	}
	if (totalReactions.length == 0 && checkBox.prop("checked") == false) {
		return false;
	}
	let totalCount = checkBox
		.closest(".link-input-wrapper")
		.find(".per-post-val span")
		.text();
	let dividingAmount = Math.floor(totalCount / totalReactions.length);
	if (dividingAmount < limit) {
		createToast("error", `Minimum reactions limit is ${limit}.`);
		checkBox.prop("checked", false);
		return false;
	}
	let count = 0;
	totalReactions.each(function () {
		let reactionCount = $(this).closest("label").find(".reaction-count");
		reactionCount.removeClass("hidden");
		if (count == totalReactions.length - 1) {
			reactionCount.text(totalCount);
		} else {
			totalCount -= dividingAmount;
			reactionCount.text(dividingAmount);
		}
		count++;
	});
});

document.querySelectorAll(".post-input-check").forEach(function (elem) {
	elem.addEventListener("change", function () {
		let service = elem.closest(".service");
		service?.querySelectorAll('input[type="text"]')?.forEach((e)=>{
				e.value=''
				e.dispatchEvent(new Event('input', { bubbles: true }));
		});
		let slider = service.querySelector('input[type="range"]');
		slider.dispatchEvent(new Event("input"));
	});
});

$(".current-links-videos").click(function () {
	let current = $(this);
	let text = current.text();
	let siblingCheckbox = current.siblings(".switch").find("input");
	if (text == "videos" && siblingCheckbox.prop("checked")) {
		siblingCheckbox.click();
	} else if (text == "links" && !siblingCheckbox.prop("checked")) {
		siblingCheckbox.click();
	}
});
